import { IconButton, IconCloseCircleOutline } from '@zillow/constellation';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { useDeleteTaskMutation } from 'API/order/OrderTaskAPI';
import { ConfirmDeleteModalDialog } from 'components/shared/ConfirmDelete/ConfirmDeleteModalDialog';
import React from 'react';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { IOrderTaskData } from 'types/tasks';
import { assertDefined } from 'utilities/Assertions';

interface IDeleteTaskProps {
  task: IOrderTaskData;
}

export const DeleteTask: React.FC<IDeleteTaskProps> = ({ task }) => {
  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);
  const [deleteTask] = useDeleteTaskMutation();

  const onConfirmation = async () => {
    const result = await deleteTask({ orderId, taskId: task.id! });
    checkForMutationSuccess(result, 'deleting task', 'Error deleting the task.');
  };
  return (
    <ConfirmDeleteModalDialog
      triggerElement={
        <IconButton
          icon={<IconCloseCircleOutline />}
          title={'Delete Task'}
          bare
          size={'xs'}
          data-test-id={`delete-task-${task.id}`}
        />
      }
      onConfirmation={onConfirmation}
      title={'Delete Task?'}
      message={`Please confirm deleting the task "${task.description}"`}
    />
  );
};
